export default __webpack_public_path__ + "static/media/netlify.6fffe725.svg";